const footerActionTypes = {
  FETCH_FOOTER_REQUEST: "FETCH_FOOTER_REQUEST",
  FETCH_FOOTER: "FETCH_FOOTER",
  FETCH_FOOTER_FULFILLED: "FETCH_FOOTER_FULFILLED",
  FETCH_FOOTER_REJECTED: "FETCH_FOOTER_REJECTED",
};

export default footerActionTypes;
